module.exports = __webpack_public_path__ + "static/img/4.2ff9238.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/eng/4.png
// module id = QvMr
// module chunks = 0